/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const IndiaSpecificHeader = ({
  companyTaxID, vatRegistrationNumber, digitalOrderNumber, invoiceNumber, items
}) => {
    const {
      OrderId, RL_InvoiceNumber
    } = useSelector((state) => state);

    const taxInvoiceHeader = items?.Sales?.length ? 'Tax Invoice' : null;
    const creditNoteHeader = items?.Returns?.length ? 'Credit Note' : null;
    const taxInvoiceOrCreditNoteHeader = taxInvoiceHeader || creditNoteHeader;

    const taxInvoiceNoHeader = items?.Sales?.length ? RL_InvoiceNumber : null;
    const creditNoteNoHeader = items?.Returns?.length ? 'Credit Note Number' : null;
    const invoiceOrCreditNoteNoHeader = taxInvoiceNoHeader || creditNoteNoHeader;

    return (
      <>
        {taxInvoiceOrCreditNoteHeader && <p>{taxInvoiceOrCreditNoteHeader}</p>}
        <br />
        <p>GSTN: {companyTaxID}</p>
        <p>CIN: {vatRegistrationNumber}</p>
        <br />
        <p>{OrderId}:</p>
        <p>{digitalOrderNumber ? digitalOrderNumber.match(/(.{1,5})/g).join(' ') : ''}</p>
        <br />
        <p>{invoiceOrCreditNoteNoHeader}: </p>
        <p>{invoiceNumber}</p>
        <br />
      </>
    );
};

IndiaSpecificHeader.defaultProps = {
  companyTaxID: '',
    digitalOrderNumber: '',
    invoiceNumber: '',
    items: {},
    vatRegistrationNumber: ''
};

IndiaSpecificHeader.propTypes = {
  companyTaxID: PropTypes.string,
    digitalOrderNumber: PropTypes.string,
    invoiceNumber: PropTypes.string,
    items: PropTypes.shape(),
    vatRegistrationNumber: PropTypes.string
};

export default IndiaSpecificHeader;
